export default function invertFilters(filters: App.OfferListFilters = {}) {
  return Object.entries(filters).reduce((inverted, [type, values]) => {
    inverted[type] = values.map(value => `!${value}`)
    return inverted
  }, {})
}
